import Vue from 'vue'
import App from './App.vue'
import util from './libs/util'
import iView from 'view-design'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import 'view-design/dist/styles/iview.css'
import moment from 'moment'
// bpmn
import axios from 'axios'
import router from './router/router'
import store from './store/store'
import download from '@/libs/download'
import "./style/global.css";
import { stringify } from "qs";

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

Vue.prototype.$stringify = stringify
Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.prototype.$util = util
Vue.prototype.$http = util.http
Vue.prototype.$axios = axios
Vue.prototype.$download = download


import i18n from "./i18n/index"; // 国际化模块

Vue.use(ElementUI, {size: 'small', i18n: (key, value) => i18n.t(key, value),})
Vue.use(iView)
const vm=new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
 
export default vm
